import React from 'react';
import ContentLoader from 'react-content-loader';
import { Row, Col } from 'react-bootstrap';

const SkeletonCardLoader = ({
    width = '100%',
    height = '100%',
    backgroundColor = '#f3f3f3',
    foregroundColor = '#ecebeb',
}) => (
    <ContentLoader
        speed={2}
        width={width}
        height={height}
        viewBox="0 0 100% 100%"
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
        style={{ width: '100%', height: '100%' }}
    >
        <rect x="0" y="0" rx="8" ry="8" width="100%" height="100%" />
    </ContentLoader>
);

const MasonrySkeletonLoader = ({
    items = 6,
    mdWidth = 4,
    smWidth = 12,
    cardWidth = 320,
    cardHeight = 500,
}) => (
    <Row className="justify-content-center">
        {Array.from({ length: items }).map((_, index) => (
            <Col
                key={index}
                md={mdWidth}
                sm={smWidth}
                className="card-preview mb-4 no-scroll"
                style={{ maxWidth: cardWidth }}
            >
                <div style={{ height: cardHeight }}>
                    <SkeletonCardLoader />
                </div>
            </Col>
        ))}
    </Row>
);

export default MasonrySkeletonLoader;
